import { render, staticRenderFns } from "./teleprompter_awaken.vue?vue&type=template&id=61931fe4&scoped=true"
import script from "./teleprompter_awaken.vue?vue&type=script&lang=js"
export * from "./teleprompter_awaken.vue?vue&type=script&lang=js"
import style0 from "./teleprompter_awaken.vue?vue&type=style&index=0&id=61931fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61931fe4",
  null
  
)

export default component.exports